import { formatter } from "@/app/checkout/(squeeze)/review/checkoutReviewPage";
import { CheckoutReviewVendorOrderSectionProps } from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSection";
import styles from "./checkoutReviewVendorOrderSection.module.scss";

export default function CheckoutReviewVendorOrderSectionFooter({
  shoppingCartVendorOrder,
}: CheckoutReviewVendorOrderSectionProps) {
  const isFreeShipping = !shoppingCartVendorOrder?.standardShipping;
  return (
    <div className={styles.footer}>
      <table className={styles.summaryTable}>
        <tbody>
          <tr>
            <td>Subtotal</td>
            <td>{shoppingCartVendorOrder?.subtotal ? formatter.format(shoppingCartVendorOrder?.subtotal) : "$0.00"}</td>
          </tr>
          <tr>
            <td>Standard Shipping</td>
            <td className={isFreeShipping ? styles.free : undefined}>
              {isFreeShipping ? "FREE" : formatter.format(shoppingCartVendorOrder?.standardShipping)}
            </td>
          </tr>
          {shoppingCartVendorOrder?.heavyShipping > 0 && (
            <tr>
              <td>Heavy Shipping Surcharge</td>
              <td>{formatter.format(shoppingCartVendorOrder?.heavyShipping)}</td>
            </tr>
          )}
          <tr>
            <td>Estimated Tax</td>
            <td>{shoppingCartVendorOrder?.totalTax ? formatter.format(shoppingCartVendorOrder?.totalTax) : "$0.00"}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Vendor Order Total</td>
            <td>{shoppingCartVendorOrder?.total ? formatter.format(shoppingCartVendorOrder?.total) : "$0.00"}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
